import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {
  BannerRes,
  Category,
  CatalogReq,
  CatalogRes, GoponRes2,
  ItemDetailsReq,
  ItemDetailsRes,
  ItemsReq,
  ItemsRes,
  Pagable,
  RelatedItemsReq,
  WishlistRes
} from "@app/core/models";
import {environment} from '@environments/environment';
import {BehaviorSubject, noop, Observable, shareReplay, take, tap,} from 'rxjs';
import { GetCategoryItem, GetHomeBanner, Gopon_Home } from "@core/models/general/general.models";
import { log } from "@angular-devkit/build-angular/src/builders/ssr-dev-server";

@Injectable({
  providedIn: 'root',
})
export class CatalogService {
  private defaultCat: Category = {
    Id: -1,
    Image: '',
    Name: '',
    Categories:[],
  };
  private baseUrl = environment.API_BASE_URL + 'Catalog/';
  private getCategoriesUrl = this.baseUrl + 'GetCategories';
  private getItemsUrl = this.baseUrl + 'GetItems';
  private getItemListUrl = this.baseUrl + 'GetItemList';
  private getBannerUrl = this.baseUrl + 'GetBanner';
  private getItemsForHomePage = this.baseUrl + 'GetItemsForHome';
  private getCategoryItemList = this.baseUrl + 'GetCategoryItemList';
  private getHomeBannerList = this.baseUrl + 'GetHomeBannerList';
  private getItemDetailsUrl = this.baseUrl + 'GetItemDetails';
  private getRelatedItemsUrl = this.baseUrl + 'GetRelatedItems';
  private addWishListItemUrl = this.baseUrl + 'AddWishListItem';
  private deleteWishListItemUrl = this.baseUrl + 'DeleteWishListItem';
  private getWishListUrl = this.baseUrl + 'GetWishList';
  currentCatalog$: BehaviorSubject<Category> = new BehaviorSubject(
    this.defaultCat
  );
  constructor(private readonly http: HttpClient) {}

  getCategories(
    body: CatalogReq,
    loadMore: boolean = false
  ): Observable<CatalogRes> {
    return this.http.get<CatalogRes>(this.getCategoriesUrl, {params: body as any})
      .pipe(
      shareReplay(1),
      take(1),
      tap((res) => {
        //console.log('res', res);
        //loadMore ? noop() : this.currentCatalog$.next(res.Categories[0]);
      })
    );
  }
  getCategoriesForAllOnly(
    body: CatalogReq,
    loadMore: boolean = false
  ): Observable<CatalogRes> {
    return this.http.get<CatalogRes>(this.getCategoriesUrl, {params: body as any})
      .pipe(
      shareReplay(1),
      take(1),
      tap((res) => {
        //console.log('res', res);
        loadMore ? noop() : this.currentCatalog$.next(res.Categories[0]); // get all
      })
    );
  }

  getBanner(body: Pagable): Observable<BannerRes> {
    return this.http
      .get<BannerRes>(this.getBannerUrl, { params: body as any })
      .pipe(shareReplay(1), take(1));
  }
  getItems(body: ItemsReq): Observable<ItemsRes> {
    return this.http
      .get<ItemsRes>(this.getItemListUrl, { params: body as any })
      .pipe(shareReplay(1), take(1));
  }
  getItemDetails(body: ItemDetailsReq): Observable<ItemDetailsRes> {
    if (body.attributes?.length??0 > 0) {
      return this.http
        .post<ItemDetailsRes>(this.getItemDetailsUrl, body)
        .pipe(shareReplay(1), take(1));
    }
    return this.http
      .get<ItemDetailsRes>(this.getItemDetailsUrl, { params: body as any })
      .pipe(shareReplay(1), take(1));
  }
  getRelatedItems(body: RelatedItemsReq): Observable<ItemsRes> {
    return this.http
      .get<ItemsRes>(this.getRelatedItemsUrl, { params: body as any })
      .pipe(shareReplay(1), take(1));
  }
  getWishList(body: Pagable): Observable<ItemsRes> {
    return this.http
      .get<ItemsRes>(this.getWishListUrl, { params: body as any })
      .pipe(shareReplay(1), take(1));
  }
  addWishListItem(itemId: number): Observable<WishlistRes> {
    return this.http
      .post<WishlistRes>(this.addWishListItemUrl, { itemId })
      .pipe(shareReplay(1), take(1));
  }
  deleteWishListItem(itemId: number): Observable<WishlistRes> {
    return this.http
      .delete<WishlistRes>(this.deleteWishListItemUrl, { params: { itemId } })
      .pipe(shareReplay(1), take(1));
  }
  getItemsForGoponHomePage() {
    return this.http.get<GoponRes2<{Data:Gopon_Home}>>(this.getItemsForHomePage);
  }
  getCategoryItemListHomePage() {
    return this.http.get<GoponRes2<{Data:GetCategoryItem[]}>>(this.getCategoryItemList);
  }
  getHomeBannerListHomePage() {
    return this.http.get<GoponRes2<{Data:GetHomeBanner[]}>>(this.getHomeBannerList);
  }

}
